<template>
  <div>
    <div class="documents">
      <div
        class="col-36"
        v-if="meta.attestationPiecesJustificatives?.$status === PropertyStatus.Required"
      >
        <WrapperCheckbox
          id="field_attestationPiecesJustificatives"
          v-model="attestationPiecesJustificativesModel"
          :alertLabel="meta.attestationPiecesJustificatives?.$messageErreurDirty!"
          label="L'employeur atteste disposer de l'ensemble des pièces justificatives nécessaires au dépôt du dossier"
          :readonly
          class="wrapper-width-fit wrapper-without-margin-top"
        ></WrapperCheckbox>
      </div>
      <UploadFichiers />
    </div>
    <DocumentsStepDrfSection v-if="store.estDossier" />
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { DEMANDE_STORE, UploadFichiers } from '@/features/interface/demande/shared/components'
  import { inject } from 'vue'
  import DocumentsStepDrfSection from '@/features/interface/demande/cxpi/steps/documents/DocumentsStepDRFSection.vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { setupFieldWithKey } = store

  const { meta, readonly } = storeToRefs(store)

  const attestationPiecesJustificativesModel = setupFieldWithKey<boolean>('attestationPiecesJustificatives')
</script>

<style scoped lang="less">
  .documents {
    display: flex;
    flex-direction: column;
    gap: @spacing-25;
    margin-bottom: @spacing-25;
    // height: 100vh;
    &__section {
      display: flex;
      flex-direction: column;
      gap: @spacing-15;

      &__button {
        width: 500px;
      }
    }
  }
</style>
